// components/subscription/PlanCard.jsx
import React from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';

const PlanCard = ({ plan, onSelect }) => {
  const { currentPlan } = useSubscription();
  const isCurrentPlan = currentPlan && currentPlan.id === plan.id;

  // Parse features from plan description
  const features = plan.description.split('\n').filter(item => item.trim().startsWith('-'));
  
  return (
    <div className={`border rounded-lg p-6 ${isCurrentPlan ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`}>
      <h3 className="text-xl font-semibold mb-2">{plan.name}</h3>
      <div className="text-2xl font-bold mb-4">
        ₹{parseFloat(plan.price).toFixed(2)}
        <span className="text-sm font-normal text-gray-600 ml-1">
          / {plan.period === 1 ? 'month' : `${plan.period} months`}
        </span>
      </div>
      
      {plan.discount > 0 && (
        <div className="mb-4 px-3 py-1 bg-green-100 text-green-800 rounded inline-block">
          Save {plan.discount}%
        </div>
      )}
      
      <div className="mb-6">
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <span className="text-green-500 mr-2">✓</span>
              <span>{feature.substring(1).trim()}</span>
            </li>
          ))}
        </ul>
      </div>
      
      <button
        onClick={onSelect}
        disabled={isCurrentPlan}
        className={`w-full py-2 px-4 rounded-md ${
          isCurrentPlan 
            ? 'bg-blue-100 text-blue-800 cursor-default' 
            : 'bg-blue-600 text-white hover:bg-blue-700'
        }`}
      >
        {isCurrentPlan ? 'Current Plan' : 'Select Plan'}
      </button>
    </div>
  );
};

export default PlanCard;